import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/views/servicePagesSections/priceStyles.js"

const useStyles = makeStyles(styles);

export default function PriceListing(props) {
    const classes = useStyles();
    const Listing = ({ product, price }) => (
        <GridContainer>
          <GridItem xs={6}>
                <h3 className={classes.product}>{product}</h3>
            </GridItem>
            <GridItem xs={6}>
                <h3 className={classes.prices}>{price}</h3>
            </GridItem>
        </GridContainer>
      )
    function createListings() {
        const items = []
        for(var i = 0; i < props.products.length; i++) {
            items.push(<Listing product={props.products[i].name} price={props.products[i].price}/>)
        }
        return items
    }   
  return (
    <div className={classes.section}>
      <h2 className={classes.title}>Prices</h2>
      <p className={classes.title}>*All prices are subject to change at anytime.*</p>
      <div className={classes.description}>
        {createListings()}        
      </div>
    </div>
  );
}
